import { styled } from '@mui/system'
import { Box, Grid, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { MuiButton } from '../../../components'

export const Wrapper = styled(Grid)(`        
`)

export const TableOuterWrapper = styled(Box)(`
  width: 100%;
  display:flex;
  gap: 16px;
  border-radius: 4px;
  border: 1px #D8D8D6 solid;
`)

export const TableHeadWrapper = styled(TableHead)(`
  background: transparent;
  padding:20px 0;
  & img {
    padding:0 10px;
  }
`)

export const TableBodyWrapper = styled(TableBody)(`
  background:transparent;
  & .tr_heading{border:0; border-top: 1px #D8D8D6 solid; cursor: pointer !important;}
  & .tr_heading:hover{background:#F2F8FF;}
  & .tr_true{background:#F2F8FF;}
  & tr{min-height: 48px;}
  & td{
    border:0; text-transform: none !important; padding:7px 12px;
    font-weight: 400; // 300;
    }
`)

export const TableRowContent = styled(TableRow)(`
  background:#F2F8FF;
  & .tableCell{
    padding-bottom: 0;
    padding-top: 0;
    background: #FFF;
    & .tr_collapse {
      /* border: 1px blue solid; */
    }
  }
`)

export const TableCellHead = styled(TableCell)(`
  cursor: pointer !important;
  text-transform: none !important;
  font-weight:600 !important;
  font-size:14px !important;
  line-height:21px !important;
  padding:7px 12px;
`)

export const CollapseContent = styled(Box)(
  (props) => `
    display:flex;
    flex-direction:column;
    align-items:center;
    border-radius: 4px;
    border: 1px solid #095BBD;
    padding: 16px;
    & .CollapseRightIconWrapper {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
`
)

export const TableChipCompleted = styled(MuiButton)(`
    padding:6px 0;
    margin-right: 5px;
    width:85px;
    text-align:center;
    
    font-weight: 400;
    font-size: 10px;
    line-height: 15px;

    color: #008767;
`)

export const TableChipAdminReview = styled(MuiButton)(`
    padding:6px 0;
    margin-right: 5px;
    width:85px;
    text-align:center;
    
    font-weight: 400;
    font-size: 10px;
    line-height: 15px;

    color: #429F8A;
`)

export const TableChipInProgress = styled(MuiButton)(`
    padding:6px 0;
    margin-right: 5px;
    width:85px;
    text-align:center;
    
    font-weight: 400;
    font-size: 10px;
    line-height: 15px;

    color: #C88F16;
    cursor:pointer;
`)

export const InnerWrapper = styled(Box)(
  (props) => `
  color: ${props.type.toLowerCase() === 'completed' ? '#000' : '#7E7E7E'};
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 560px;
  gap: 8px;
  & > div {
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }
`
)

export const PhaseWrapper = styled(Box)(`
  font-size: 14px;
  font-weight: 400; // 300;
  width: 100%;
`)
export const ChipsWrapper = styled(Box)(`
  width: 200px;
  display: flex;
  justify-content: flex-end;

  & button {
    font-size: 14px;
    font-weight: 600;
    line-height: 0;
    padding: 0 16px;
    margin: 0;
    width: auto;
    text-wrap-mode: nowrap;
  }
`)

export const ArrowWrapper = styled(Box)(`
  width: 25px;
`)

export const RhsOuterWrapper = styled(Box)(`
  width: 40%;
  min-width:460px;
`)

export const RhsWrapper = styled(Box)(`
  width: 100%;
`)

export const TopSection = styled(Box)(`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 76px;
  position: relative;
  min-height: 76px;
  padding-top: 4px;

  .imageIcon {
    position: absolute; top: 0; left: 0;
  }
`)

export const TopSectionHeading1 = styled(Box)(`
  font-size: 22px;
  font-weight: 400;
`)

export const TopSectionHeading2 = styled(Box)(`
  font-size: 16px;
  font-weight: 400;
`)

export const DateWrapper = styled(Box)(`
  display: flex;
  align-items: center;
  & svg { margin-left: 5px; }
`)
